import { render, staticRenderFns } from "./LicenseDashboard.vue?vue&type=template&id=0fb4131a&scoped=true"
import script from "./LicenseDashboard.vue?vue&type=script&lang=js"
export * from "./LicenseDashboard.vue?vue&type=script&lang=js"
import style0 from "./LicenseDashboard.vue?vue&type=style&index=0&id=0fb4131a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb4131a",
  null
  
)

export default component.exports